import IBreadcrumbsJsonLd from '~/jsonLd/types/IBreadcrumbsJsonLd';
import { IBreadcrumbs } from '~/types/IRouteInfo';

import IBreadcrumbsJsonLdParams from '../types/IBreadcrumbsJsonLdParams';

const mapBreadcrumbsToJsonLd = (params: IBreadcrumbsJsonLdParams): IBreadcrumbsJsonLd | null => {
  const { breadcrumbs, host } = params;

  return {
    '@context': 'http://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumbs?.map((breadcrumb: IBreadcrumbs, index: number) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: breadcrumb.Nazwa,
      item: `${host}${breadcrumb.Url}`,
    })),
  };
};
export default mapBreadcrumbsToJsonLd;
